import { render, staticRenderFns } from "./User.vue?vue&type=template&id=3a57d96c&scoped=true&"
import script from "./user.ts?vue&type=script&lang=ts&"
export * from "./user.ts?vue&type=script&lang=ts&"
import style0 from "./User.vue?vue&type=style&index=0&id=3a57d96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57d96c",
  null
  
)

export default component.exports